import React from 'react';
import PatientSelector from '../../PatientSelector/PatientSelector';

const BottomBar = ({
  templates,
  selectedTemplate,
  missingSections,
  selectedJournalSystem,
  onTemplateChange,
  onAddSection,
  onJustera,
  onRegenerate,
  onTransfer,
  onImagesClick,
  onSearchClick,
  // Props för patientjournal-integration
  patientId,
  selectedPatient,
  onPatientSelect,
  onPatientClear,
  useInternalJournal,
  onSaveToPatient,
  onSignJournal,
  isSaving,
  isSigning,
  savedEntryId
}) => {
  const handleSelectTemplate = (e) => {
    const newId = parseInt(e.target.value, 10);
    if (!isNaN(newId) && newId !== selectedTemplate?.template_id) {
      onTemplateChange(newId);
    }
  };

  const handleMissingChange = (e) => {
    const id = parseInt(e.target.value, 10);
    if (!id) return;
    const found = missingSections.find((m) => m.id === id);
    if (!found) return;
    onAddSection(found);
    e.target.value = "";
  };

  return (
    <div className="bottom-bar">
      <select
        className="template-bottom-select"
        onChange={handleSelectTemplate}
        value={selectedTemplate?.template_id ?? ""}
      >
        {templates.map((t) => (
          <option key={t.template_id} value={t.template_id}>
            {t.template_name}
          </option>
        ))}
      </select>

      <select
        className="template-bottom-select"
        onChange={handleMissingChange}
      >
        <option value=""> Lägg till rubrik </option>
        {missingSections.map((ms) => (
          <option key={ms.id} value={ms.id}>
            {ms.section_title}
          </option>
        ))}
      </select>

      <button className="adjust-button primary-btn" onClick={onJustera}>
        Justera anteckning
      </button>

      <button className="images-button primary-btn" onClick={onImagesClick}>
        Bilder
      </button>

      <button className="regenerate-button primary-btn" onClick={onRegenerate}>
        Gör om journal
      </button>

      {onSearchClick && (
        <button
          className="search-button primary-btn"
          onClick={onSearchClick}
          title="Sök i journaler (Ctrl+F)"
        >
          <i className="fas fa-search"></i>
        </button>
      )}

      <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px', alignItems: 'center' }}>
        {useInternalJournal && (
          // Patientväljare - visas bara om inbyggd journal används
          <div className="bottom-bar-patient-selector">
            <PatientSelector
              selectedPatient={selectedPatient}
              onPatientSelect={onPatientSelect}
              onClear={onPatientClear}
              placeholder="Välj patient..."
              compact={true}
            />
          </div>
        )}

        {useInternalJournal && (
          <>
            <button
              className="save-button primary-btn"
              onClick={onSaveToPatient}
              disabled={isSaving || isSigning || !patientId}
              title={!patientId ? 'Välj en patient först' : ''}
            >
              {isSaving ? 'Sparar...' : savedEntryId ? 'Uppdatera' : 'Spara till journal'}
            </button>
            <button
              className="sign-button"
              onClick={onSignJournal}
              disabled={isSaving || isSigning || !patientId}
              title={!patientId ? 'Välj en patient först' : ''}
            >
              {isSigning ? 'Signerar...' : 'Signera'}
            </button>
          </>
        )}
        {(!useInternalJournal || selectedJournalSystem) && (
          <>
            {useInternalJournal && <span className="bottom-bar-separator">|</span>}
            <button className="transfer-button" onClick={onTransfer}>
              För över till {selectedJournalSystem}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BottomBar;